<template>
    <div> 
        <Header></Header> 
        <div class="boardOfDirectors">
            <div class="container-fluid">
                <div>
                    <h1 class="heading-primary">{{ this.bod.title }}</h1>
                </div>
                <boardOfDirectors :members="this.bod.members" class="mt-md" />
            </div>
        </div>
  </div>
</template>

<script>
import boardOfDirectors from "@/components/boardOfDirectors/members.vue";
import bod from '@/components/boardOfDirectors/data/bod';
export default {
    name: "App",
    data() {
        return {
            bod: bod,
        };
    },
    created(){
        this.$i18n.locale=="en" ?
            this.bod = this.bod.en :
            this.bod = this.bod.ar;
    },
    components: {
        boardOfDirectors,
    },
};
</script>
<style lang="scss">
    [data-page="board-directors"]{
        .verticalLabel {
              color: #000;  
        }
        @media screen and (max-width:575px){
            overflow:hidden;
        }
        
    }
    .js-focus-visible{
        @media screen and (max-width:575px){
            overflow:hidden;
        }
    }
</style>
<style lang="scss" scoped>
    .boardOfDirectors{
        width: 100%;
        height: 100vh;
        display:flex;
        align-items:center;
        background: url(../../assets/images/banners/board-of-directors.png);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        overflow: hidden;
        @media screen and (max-width:991px){
            padding-top:85px;
            @media screen and (min-width:575px){
                padding-top:57px;
            }
        }
        h1{
            &.heading-primary{
                font-size:rem(35px);
                text-align:center;
                max-width:1080px;
                margin:auto auto rem(70px) auto;
                @media screen and (max-width:1600px){
                    font-size:rem(25px);
                    margin:auto auto rem(30px) auto;
                }
                @media screen and (max-width:991px){
                    font-size:rem(20px);
                    margin-bottom:rem(12px);
                }
                @media screen and (max-width:575px){
                    position: absolute;
                    top: 90px;
                    padding: 0 20px;
                    text-align: center;
                    left: 0;
                    right: 0;
                    margin: auto;
                }
            }
        }
        
    }
    /deep/{
        .verticalLabel{
            color:#000;
        }
        strong{
            font-weight:900 !important;
        }
    }
[lang="ar"] {
    
}
</style>